import React, { useState } from 'react';
import './GameCarousel.css';
import arrowLeftMobile from '../assets/网站设计/移动端切图/arrow_left_n.webp';
import arrowRightMobile from '../assets/网站设计/移动端切图/arrow_right_n.webp';
import arrowLeftDesktop from '../assets/网站设计/PC端切图/arrow_left_n.webp';
import arrowRightDesktop from '../assets/网站设计/PC端切图/arrow_right_n.webp';
import carousel1 from '../assets/carousel/1.webp';
import carousel2 from '../assets/carousel/2.webp';
import carousel3 from '../assets/carousel/3.webp';
import carousel4 from '../assets/carousel/4.webp';
import carousel5 from '../assets/carousel/5.webp';
import carousel6 from '../assets/carousel/6.webp';
import carousel7 from '../assets/carousel/7.webp';
import carousel8 from '../assets/carousel/8.webp';
import carousel1Mobile from '../assets/carousel/1_mobile.webp';
import carousel2Mobile from '../assets/carousel/2_mobile.webp';
import carousel3Mobile from '../assets/carousel/3_mobile.webp';
import carousel4Mobile from '../assets/carousel/4_mobile.webp';
import carousel5Mobile from '../assets/carousel/5_mobile.webp';
import carousel6Mobile from '../assets/carousel/6_mobile.webp';
import carousel7Mobile from '../assets/carousel/7_mobile.webp';
import carousel8Mobile from '../assets/carousel/8_mobile.webp';

interface GameCarouselProps {
  isMobile: boolean;
}

const GameCarousel: React.FC<GameCarouselProps> = ({ isMobile }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const carouselData = [
    {
      image: isMobile ? carousel1Mobile : carousel1,
      title: "Build your totalitarian space colony"
    },
    {
      image: isMobile ? carousel2Mobile : carousel2,
      title: "SURVIVE OVERWHELMING FIRE"
    },
    {
      image: isMobile ? carousel3Mobile : carousel3,
      title: "Gather resources, research, and expand your base"
    },
    {
      image: isMobile ? carousel4Mobile : carousel4,
      title: "Craft weapons, armor, ships, and vehicles"
    },
    {
      image: isMobile ? carousel5Mobile : carousel5,
      title: "Launch expeditions to expand your regime"
    },
    {
      image: isMobile ? carousel6Mobile : carousel6,
      title: "Command your troops in tactical battles"
    },
    {
      image: isMobile ? carousel7Mobile : carousel7,
      title: "Fight in fast-paced roguelite FPS combat"
    },
    {
      image: isMobile ? carousel8Mobile : carousel8,
      title: "Grow stronger by collecting Core Fragments"
    }
  ];

  const totalSlides = carouselData.length;

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  return (
    <section className={`game-carousel ${isMobile ? 'game-carousel--mobile' : 'game-carousel--desktop'}`}>
      <div className="carousel-container">
        <button className="carousel-arrow carousel-arrow--left" onClick={prevSlide}>
          <img
            src={isMobile ? arrowLeftMobile : arrowLeftDesktop}
            alt="Previous"
            className="arrow-img"
          />
        </button>

        <div className="carousel-content">
          <div className="game-screenshot">
            <img
              src={carouselData[currentIndex].image}
              alt={carouselData[currentIndex].title}
              className="screenshot-img"
            />
            <div className="game-text">
              <h2 className="game-title">{carouselData[currentIndex].title}</h2>
            </div>
          </div>
        </div>

        <button className="carousel-arrow carousel-arrow--right" onClick={nextSlide}>
          <img
            src={isMobile ? arrowRightMobile : arrowRightDesktop}
            alt="Next"
            className="arrow-img"
          />
        </button>
      </div>

      <div className="carousel-indicators">
        {Array.from({ length: totalSlides }).map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentIndex ? 'indicator--active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
    </section>
  );
};

export default GameCarousel;